<div class="vc-admin-schedules">
  @if (loading) {
    <div class="vc-admin-schedules__state vc-admin-schedules__state--loading">
      <i class="fas fa-spinner fa-spin"></i>
      <span>{{ "COMMON.LOADING" | translate }}</span>
    </div>
  } @else if (loadError) {
    <div class="vc-admin-schedules__state vc-admin-schedules__state--error">
      <i class="fas fa-triangle-exclamation"></i>
      <span>{{ "ADMIN.SCHEDULES.ERROR.LOAD" | translate }}</span>
      <button type="button" (click)="retryLoad()">
        {{ "COMMON.RETRY" | translate }}
      </button>
    </div>
  } @else if (hasNoSites) {
    <div class="vc-admin-schedules__state vc-admin-schedules__state--empty">
      <i class="fas fa-clinic-medical"></i>
      <span>{{ "ADMIN.SCHEDULES.EMPTY_SITES" | translate }}</span>
    </div>
  } @else {
    <form class="form vc-admin-schedules__form">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-3">
          <label>{{ "COMMON.EMPLOYEE" | translate }}</label>
          <p-select
            name="employee"
            size="small"
            [options]="users"
            [(ngModel)]="selectedUser"
            optionLabel="name"
            [filter]="true"
            filterBy="name,surname"
            [showClear]="true"
            [placeholder]="'ADMIN.SCHEDULES.SELECTOR.EMPLOYEE' | translate"
            fluid
          >
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="selectedUser">
                <div>{{ selectedUser.name }} {{ selectedUser.surname }}</div>
              </div>
            </ng-template>
            <ng-template let-user pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ user.name }} {{ user.surname }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>

        <div class="col-12 md:col-6 lg:col-3">
          <label>{{ "COMMON.SITE" | translate }}</label>
          <p-select
            name="site"
            [options]="sites"
            [(ngModel)]="selectedSite"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            [placeholder]="'ADMIN.SCHEDULES.SELECTOR.SITE' | translate"
            size="small"
            fluid
          >
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center gap-2" *ngIf="selectedSite">
                <div>{{ selectedSite.name }}</div>
              </div>
            </ng-template>
            <ng-template let-site pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ site.name }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>

        <div class="col-12 lg:col-6">
          <div class="p-fluid">
            <label>{{ "COMMON.FILTERS" | translate }}</label>
            <p-multiSelect
              name="site"
              [options]="sites"
              [(ngModel)]="visibleSites"
              optionLabel="name"
              (onChange)="this.loadShifts()"
              filterBy="name"
              [showClear]="true"
              [placeholder]="'ADMIN.SCHEDULES.SELECTOR.SITE' | translate"
              size="small"
              fluid
            >
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center gap-2" *ngIf="selectedSite">
                  <div>{{ selectedSite.name }}</div>
                </div>
              </ng-template>
              <ng-template let-site pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ site.name }}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <ng-template
            #weekViewHourSegmentTemplate
            let-segment="segment"
            let-locale="locale"
            let-segmentHeight="segmentHeight"
            let-isTimeLabel="isTimeLabel"
          >
            <div
              #segmentElement
              class="cal-hour-segment"
              [style.height.px]="segmentHeight"
              [class.cal-hour-start]="segment.isStart"
              [class.cal-after-hour-start]="!segment.isStart"
              [ngClass]="segment.cssClass"
              (mousedown)="startDragToCreate(segment, $event, segmentElement)"
            >
              <div class="cal-time" *ngIf="isTimeLabel">
                {{ segment.date | calendarDate : "weekViewHour" : locale }}
              </div>
            </div>
          </ng-template>

          <mwl-calendar-week-view
            [viewDate]="viewDate"
            [events]="events"
            [dayStartHour]="8"
            [locale]="this.locale"
            (eventClicked)="openEvent($event.event)"
            [hourSegmentTemplate]="weekViewHourSegmentTemplate"
            (eventTimesChanged)="eventTimesChanged($event)"
            [weekStartsOn]="weekStartsOn"
          >
          </mwl-calendar-week-view>
        </div>
      </div>
    </form>
  }
</div>
